export type ImageImport = string | { src: string };

const getImageSrc = (img: ImageImport | null | undefined): string | undefined => {
  if (img == null) return undefined;
  return typeof img === 'string' ? img : img.src;
};

export default getImageSrc;
